import { useLayoutEffect } from 'react';

import i18n from 'i18n';
import { useLanguageStore, type Language } from 'store/language.store';

/** Auth surfaces render in the site's language (Uzbek on examing.uz, English on examing.io); the saved preference is restored on unmount. */
export function useForceLanguage(language: Language): void {
  useLayoutEffect(() => {
    if (i18n.language !== language) {
      i18n.changeLanguage(language);
    }

    return () => {
      const saved = useLanguageStore.getState().language;
      if (i18n.language !== saved) {
        i18n.changeLanguage(saved);
      }
    };
  }, [language]);
}
